module.exports = __webpack_public_path__ + "static/img/empty-okr-list.fb2ef895.png";